import React from 'react';
import { Avatar, useTheme } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';

const UserAvatar = ({ user, userData, size = 40 }) => {
  const theme = useTheme();
  const borderColor = theme.palette.mode === 'dark' ? 'white' : 'black';
  const avatarUrl =
    userData?.photoURL || userData?.avatarUrl || user?.photoURL || '';

  if (avatarUrl) {
    return (
      <Avatar
        src={avatarUrl}
        sx={{
          width: size,
          height: size,
          border: '2px solid',
          borderColor,
        }}
      />
    );
  }

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        backgroundColor: 'secondary.main',
        color: 'white',
        border: '2px solid',
        borderColor,
      }}
    >
      <AccountCircle sx={{ width: size, height: size }} />
    </Avatar>
  );
};

export default UserAvatar;
